import React, { useState, useEffect } from 'react';
import { IconButton } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import { useLanguage } from 'Context/LanguageContext';
import RoleUtils from 'FielderUtils/roles/roleUtils';
import { useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { isLocalUser } from 'Utils/account/utils';
import taskConst from 'FielderUtils/roleManagementConst/taskConst';
import { isRoleValid } from '../../../core/utils/roles/validateRoles';
import { ENDPOINTS } from '../../../core/constants/pageEndpoints.constants';
import { getAccountPreferences } from '../../../core/services/customHooks/accountPreferencesUtils';
import { selectUser, selectSession } from '../../../core/store/modules/session/sessionSelectors';
import AddCircleIcon from '@mui/icons-material/AddCircle';

const TopMenuCreateTask = () => {
  const lan = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector(selectUser);
  const session = useSelector(selectSession);
  const accountPreferences = getAccountPreferences(session);
  const [isAbleToShow, setIsAbleToShow] = useState(true);
  useEffect(() => {
    let isAllowed = true;
    let isAllowToCreateTask = isRoleValid(taskConst.NAME, taskConst.CREATE, session.roles)

    if ((RoleUtils.isUserManager(user) && (!accountPreferences.allowManagerCreate || !isAllowToCreateTask))
      || !isAllowToCreateTask) {
      isAllowed = false;
    }

    const localUser = isLocalUser(user);
    setIsAbleToShow(localUser && isAllowed);
  }, [user]);

  const goToCreateTask = () => navigate(ENDPOINTS.createTask, {state: {pathname: location.pathname}});

  return (
    <>
      {isAbleToShow && (
        <Tooltip arrow title={lan.createTask}>
          <IconButton
            aria-label={lan.createTask}
            onClick={goToCreateTask}
            sx={{
              p: 0,
              color: 'text.secondary',
              transition: (theme) => theme.transitions.create('color'),
              '&:hover': {
                backgroundColor: 'transparent',
                color: 'primary.main',
              },
            }}
          >
            <AddCircleIcon fontSize="medium" />
          </IconButton>
        </Tooltip>
      )}
    </>
  );
};
export default TopMenuCreateTask;
//Original code:
/*import React, { useState, useEffect } from 'react';
import { IconButton } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import { useLanguage } from 'Context/LanguageContext';
import RoleUtils from 'FielderUtils/roles/roleUtils';
import { useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { isLocalUser } from 'Utils/account/utils';
import taskConst from 'FielderUtils/roleManagementConst/taskConst';
import { isRoleValid } from '../../../core/utils/roles/validateRoles';
import { ENDPOINTS } from '../../../core/constants/pageEndpoints.constants';
import { getAccountPreferences } from '../../../core/services/customHooks/accountPreferencesUtils';
import { selectUser, selectSession } from '../../../core/store/modules/session/sessionSelectors';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { FielderHard } from '@core/theme/baseTheme';

const TopMenuCreateTask = () => {
	const lan = useLanguage();
	const navigate = useNavigate();
	const location = useLocation();
	const user = useSelector(selectUser);
	const session = useSelector(selectSession);
	const accountPreferences = getAccountPreferences(session);
	const [isAbleToShow, setIsAbleToShow] = useState(true);
	useEffect(() => {
		let isAllowed = true;
		let isAllowToCreateTask = isRoleValid(taskConst.NAME, taskConst.CREATE, session.roles)
		if ((RoleUtils.isUserManager(user) && (!accountPreferences.allowManagerCreate || !isAllowToCreateTask))
				|| !isAllowToCreateTask) {
			isAllowed = false;
		}
		const localUser = isLocalUser(user);
		setIsAbleToShow(localUser && isAllowed);
	}, [user]);
	const goToCreateTask = () => navigate(ENDPOINTS.createTask, {state: {pathname: location.pathname}});
	return (
		<>
			{isAbleToShow && (
        <Tooltip arrow title={lan.createTask}>
          <IconButton
            onClick={goToCreateTask}
            sx={{
              p: 0,
              '& .top-menu-icon': {
                color: 'text.disabled',
              },
              '&:hover .top-menu-icon': {
                color: FielderHard,
              },
            }}
          >
            <AddCircleIcon fontSize="medium" className="top-menu-icon"/>
          </IconButton>
        </Tooltip>
			)}
		</>
	);
};
export default TopMenuCreateTask;
*/
